import content from '@ha/hypotheken-afspraak.content.json';

import { inject } from '@angular/core';

import { ApContentService } from '@ap/content';

export const contentInitializer = () => {
    const contentService = inject(ApContentService);
    contentService.addContentItems(content);
};
